import {ElementType, Fragment} from 'react';
import {WithTranslation, withTranslation} from 'react-i18next';

import NavigationLink from 'src/Components/Common/HeaderBar/NavigationMenu/NavigationLink';
import EnumRoutes from 'src/Routes/EnumRoutes';
import {getRoutePathname} from 'src/Routes/getRoutePathname';

const AllLinksBlock = (props: IAllLinksBlockProps) => {
	const linkProps = {language: props.i18n.language};
	const links = [
		{
			path: getRoutePathname(EnumRoutes.HOME, linkProps),
			text: props.t('links.home'),
		},
		{
			path: getRoutePathname(EnumRoutes.CASES, linkProps),
			text: props.t('links.cases'),
		},
		{
			path: getRoutePathname(EnumRoutes.JOBS, linkProps),
			text: props.t('links.jobs'),
		},
		{
			path: getRoutePathname(EnumRoutes.CONTACTS, linkProps),
			text: props.t('links.contacts'),
		},
	];

	const CustomTag = props.component;

	return (
		<CustomTag className={props.wrapperClass}>
			{links.map((link, idx) => (
				<NavigationLink key={idx} to={link.path} className={props.className} text={link.text} />
			))}
		</CustomTag>
	);
};

// Set default props
AllLinksBlock.defaultProps = {
	component: Fragment,
};

interface IAllLinksBlockProps extends WithTranslation {
	className?: string;
	wrapperClass?: string;
	component: ElementType;
}

export default withTranslation('navigation')(AllLinksBlock);
